import classNames from 'classnames';

import styles from './IconStar.module.scss';

interface IconStarProps {
    readonly size?: number;
    readonly selected?: boolean;
    readonly isHalf?: boolean;
}

const STAR_PATH =
    'M12 .587l3.668 7.425 8.332 1.209-6.001 5.851 1.416 8.293-7.415-3.893-7.415 3.893 1.416-8.293-6.001-5.851 8.332-1.209z';

export const IconStar = ({
    isHalf = false,
    selected = true,
    size = 17,
}: IconStarProps): JSX.Element => {
    const starClasses = classNames(styles['icon-star'], {
        [styles['icon-star--selected']]: selected,
        [styles['icon-star--half']]: isHalf,
    });

    return (
        <svg
            className={starClasses}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d={STAR_PATH} className={styles['icon-star__path-full']} />
            {isHalf && (
                <path
                    d={STAR_PATH}
                    className={styles['icon-star__path-half']}
                    clipPath="inset(0 50% 0 0)"
                />
            )}
        </svg>
    );
};
